import React, { useState, useEffect } from 'react';
import { XMarkIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { isAndroid, isUpmindyAndroidWebView } from '../utils/deviceDetection';

const STORAGE_KEY = 'upmind_app_banner_dismissed';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.upmindyapp.mobile&hl=pt_BR';

const AppDownloadBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user is on Android (but not in the webview) and hasn't dismissed the banner
    const isDismissed = localStorage.getItem(STORAGE_KEY);
    
    if (isAndroid() && !isUpmindyAndroidWebView() && !isDismissed) {
      // Show banner after a short delay for better UX
      setTimeout(() => {
        setIsVisible(true);
      }, 1000);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsVisible(false);
  };

  const handleDownload = () => {
    window.open(PLAY_STORE_URL, '_blank');
    handleDismiss();
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <ArrowDownTrayIcon className="w-5 h-5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium">
                Baixe o app Upmindy
              </p>
              <p className="text-xs opacity-90 truncate">
                Melhor experiência, acesso offline e mais rápido
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={handleDownload}
              className="px-4 py-1.5 bg-white text-blue-600 rounded-lg text-sm font-semibold hover:bg-blue-50 transition-colors"
            >
              Baixar
            </button>
            <button
              onClick={handleDismiss}
              className="p-1.5 hover:bg-blue-600 rounded-lg transition-colors"
              aria-label="Fechar"
            >
              <XMarkIcon className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
